import {
  customerList,
  paymentTermList,
  customerServiceHistory,
} from "constants/customer";

const initialState = {
  customerList: {},
  paymentTermList: {},
  customerServiceHistory: {},
};

const customer = (state = initialState, action) => {
  switch (action.type) {
    case customerList:
      return { ...state, customerList: action.payload };
    case paymentTermList:
      return { ...state, paymentTermList: action.payload };
    case customerServiceHistory:
      return { ...state, customerServiceHistory: action.payload };
    default:
      return state;
  }
};

export default customer;
